/**
 * Cap on comma-separated entries shown in a single spec value, so values like
 * a long color-variant list don't blow out the row height. Tuned for typical
 * specs that contain a handful of items (e.g. connectivity options).
 */
export const MAX_VALUE_ENTRIES = 4

export function formatSpecValue(val: unknown): string {
  if (val == null) return '-'
  if (typeof val === 'boolean') return val ? 'Yes' : 'No'
  const text = String(val).trim()
  if (!text) return '-'
  // Split on commas but only treat as a list if there's plausibly multiple
  // discrete entries (each part is short-ish — avoids mangling prose).
  const parts = text
    .split(',')
    .map((p) => p.trim())
    .filter(Boolean)
  const looksLikeList =
    parts.length > MAX_VALUE_ENTRIES && parts.every((p) => p.length <= 40)
  if (looksLikeList) {
    const visible = parts.slice(0, MAX_VALUE_ENTRIES).join(', ')
    return `${visible}, +${parts.length - MAX_VALUE_ENTRIES} more`
  }
  return text
}

// Drop only null / empty-string specs at render time. We deliberately
// keep boolean `false` so legitimate negative feature flags ("Noise
// cancelling: No", "Battery operated: No", "Portable: No") still render —
// the noise we wanted to filter (clogs/heels/wedges yes-no flags) is
// scoped to the report's subcategory and removed upstream in
// `dropTaxonomyClassifierSpecs` during projection.
export function isRenderableSpecValue(value: unknown): boolean {
  if (value == null) return false
  if (typeof value === 'string' && value.trim() === '') return false
  return true
}
